export const RUN_DISPLAY_NAME_METADATA_KEY = 'highstakes__display_name';

type RunWithDisplayName = {
  displayName: string;
  additionalMetadata?: object;
};

export function runDisplayName(run: RunWithDisplayName): string {
  const metadata = run.additionalMetadata as
    Record<string, unknown> | undefined;
  const customName = metadata?.[RUN_DISPLAY_NAME_METADATA_KEY];

  return typeof customName === 'string' && customName.trim()
    ? customName.trim()
    : run.displayName;
}
